import {Reward} from '../../components/reward/reward.types';

export const REWARDS: Reward[] = [
	{
		thumb: '/img/redeem/redeem01.png',
		title: '12 Month Napster Subscription',
		set: '10,000',
	},
	{
		thumb: '/img/redeem/redeem02.png',
		title: 'NFT of show setlist',
		set: '5,000',
	},
	{
		thumb: '/img/redeem/redeem03.png',
		title: '2x Free Tickets to a City Winery Event',
		set: '25,000',
	},
];
